<template>
  <div class="plate" @click="$bus.addGA('select_plate', 'click')" :class="$bus.ComPool.status ? 'disabled': ''">
    <Item v-for="(item, index) in $bus.actInfo.discounts" :key="item" :index="index"></Item>
  </div>
</template>

<script>
import Item from '@/components/plate/item.vue'
export default {
  components: {
    Item
  }
}
</script>

<style lang="scss" scoped>
.plate {
  @include flexrc;
  justify-content: space-between;
  @include px2res(width, 1220);
  margin: 0 auto;
}
.plate.disabled {
  filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/plate/index.vue